import { render, staticRenderFns } from "./icon-gift.vue?vue&type=template&id=06c6fa6e&scoped=true&"
import script from "./icon-gift.vue?vue&type=script&lang=js&"
export * from "./icon-gift.vue?vue&type=script&lang=js&"
import style0 from "./icon-gift.vue?vue&type=style&index=0&id=06c6fa6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c6fa6e",
  null
  
)

export default component.exports